export default "__VITE_ASSET__ComgUXFT__"